import { useEffect } from 'react';
import { Capacitor, SystemBars, SystemBarsStyle } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { useTheme } from '../contexts/ThemeContext';

/** Theme chrome belongs to every route, including native guest and legal pages. */
export default function NativeAppearance() {
  const { actualTheme } = useTheme();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;
    const dark = actualTheme === 'dark';
    // Capacitor 8 names both enums for the background: Dark uses light icons.
    // iOS keeps a separate status background because overlaysWebView is false.
    // Modern Android draws its edge-to-edge background from the web surface.
    const updates = [
      StatusBar.setStyle({ style: dark ? Style.Dark : Style.Light }),
      SystemBars.setStyle({ style: dark ? SystemBarsStyle.Dark : SystemBarsStyle.Light }),
      StatusBar.setBackgroundColor({ color: dark ? '#121212' : '#fafaf9' }),
    ];
    void Promise.all(updates).catch((error: unknown) => {
      console.warn('Tragenda system bar appearance could not be updated.', error);
    });
  }, [actualTheme]);

  return null;
}
